import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getTracking
}

function getTracking(orderId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/trackings/${orderId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}